import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ReactTable from "components/ReactTable/ReactTableServerPagination";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import SweetAlert from "react-bootstrap-sweetalert";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import styles_alert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import axios from "axios";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

const useStyles_alert = makeStyles(styles_alert);

export default function ReportsTable() {
  const [redirctTo, setRedirctTo] = useState(false);
  const [RedirctTo_edit, setRedirctTo_edit] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [alert, setAlert] = React.useState(null);
  const [isLoading, setLoading] = useState(true);
  const [token_logged, settoken_logged] = useState("");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [sortOrder, setOrder] = useState("desc");
  const [filterValues, setFilterValues] = useState({
    case_number: "",
    sub_case_number: "",
    report_name: "",
    address: "",
    status: "1,2",
  });
  const [debounceFilterValues, setDebounceFilterValues] = useState({
    case_number: "",
    sub_case_number: "",
    report_name: "",
    address: "",
    status: "1,2",
  });
  const getReports = async () => {
    try {
      setLoading(true);
      const filteredDebounceFilters = Object.fromEntries(
        Object.entries(debounceFilterValues).filter(([key, value]) => value !== "")
      );
      let url=`/report?limit=${pageSize}&page=${currentPage}&sort=${sortColumn}&sort_order=${sortOrder}`;
      if (Object.keys(filteredDebounceFilters).length > 0) {
        url += `&${new URLSearchParams(filteredDebounceFilters).toString()}`;
      }
      const res3 = await axios.get(
        url,
        {
          headers: { Authorization: token_logged },
        }
      );

      setData(res3?.data?.data);
      setTotalPages(res3?.data?.pages);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.getElementById("test_id").innerHTML = "Reports";

    const local_login = localStorage.getItem("local_login");
    let token = "";
    if (local_login) {
      try {
        const getToken = async () => {
          const res = await axios.post("/user/refresh_token", null);
          token = res.data.access_token;
          settoken_logged(token);
          await axios.get("/user/infor", {
            headers: { Authorization: token },
          });

          // const res3 = await axios.get('/codeset/all_reports', {
          //   headers: {Authorization: token}
          // })
        };
        getToken();
      } catch (err) {
        setRedirctTo(true);
      }
    } else {
      setRedirctTo(true);
    }
  }, []);
  useEffect(() => {
    getReports();
  }, [pageSize, currentPage,debounceFilterValues,sortOrder,sortColumn]);

  useEffect(() => {
  
    const debounceTimeout = setTimeout(() => {
      setDebounceFilterValues(filterValues);
       setCurrentPage(1);
    }, 2000);

    return () => {
      clearTimeout(debounceTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues]);


  const classes = useStyles();
  const classes_alert = useStyles_alert();
  const fillButtons = (id,disabled) => (
    <div>
      <Button
        onClick={(e) => warningWithConfirmAndCancelMessage(id, e)}
        color="danger"
        className={classes.actionButton}
        key={id}
        // disabled={disabled}
      >
        <Close className={classes.icon} />
      </Button>
    </div>
  );
  const simpleButtons = [{ color: "danger", icon: Close }].map((prop, key) => {
    return (
      <Button
        color={prop.color}
        simple
        className={classes.actionButton}
        key={key}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });
  const roundButtons = [
    { color: "info", icon: Person },
    { color: "success", icon: Edit },
    { color: "danger", icon: Close },
  ].map((prop, key) => {
    return (
      <Button
        round
        color={prop.color}
        className={classes.actionButton + " " + classes.actionButtonRound}
        key={key}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  let datatable1 = [];

  for (let index = 0; index < data.length; index++) {
    const { report, ...rest } = data[index];
    let report_item = { ...rest };
    let createdAt = new Date(data[index].createdAt.split("T")[0]);
    /* Date format you have */
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthIndex = createdAt.getMonth();
    let monthName = monthNames[monthIndex];
    let dateMDY = `${monthName} ${createdAt.getDate()} ${createdAt.getFullYear()}`;
    report_item.createdAt = dateMDY;
    report_item.actions = fillButtons(data[index]._id,report_item.status===2);
    report_item.url = "/admin/report/" + data[index]._id + "/1";

    datatable1.push(report_item);
  }

  const datatable = datatable1;

  if (redirctTo) {
    return <Redirect to="/auth/login-page" />;
  }

  if (RedirctTo_edit) {
    return <Redirect to={"/admin/edit-codeset/" + RedirctTo_edit} />;
  }

  function formatDate(string) {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  }

  const warningWithConfirmAndCancelMessage = (id, e) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => successDelete(id)}
        onCancel={() => cancelDetele()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
        cancelBtnCssClass={classes_alert.button + " " + classes_alert.danger}
        confirmBtnText="Yes, delete it!"
        cancelBtnText="Cancel"
        showCancel
      ></SweetAlert>
    );
    e.stopPropagation();
  };

  const open_edit = (id, e) => {
    setRedirctTo_edit(id);
    e.stopPropagation();
  };

  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
      ></SweetAlert>
    );
  };

  const successDelete = async (id) => {
    try {
      await axios.patch(
        "/codeset/update_status_report",
        {
          codeset_id_update: id,
        },
        {
          headers: { Authorization: token_logged },
        }
      );
       const fData=data.filter((item)=>item._id!==id)
       setData(fData);
      //console.log(res.data.msg);

      //setRedirctTo_new_user(true);
    } catch (err) {
      //err.response.data.msg &&
      //setUser({...user, err: err.response.data.msg, success: ''})
    }

    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes_alert.button + " " + classes_alert.success}
      ></SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <GridContainer>
      {alert}
      <GridItem xs={12}>
        <div className={classes.right}></div>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}></h4>
          </CardHeader>
          <div style={{ width: "100%", overflow: "auto" }}>
            <CardBody style={{ width: "100%", overflow: "auto" }}>
              <ReactTable
                style={{ width: "100%", overflow: "auto" }}
                columns={[
                  {
                    Header: "Case Number",
                    accessor: "case_number",
                    isFilter: true,
                  },
                  {
                    Header: "Number",
                    accessor: "sub_case_number",
                    isFilter: true,
                  },
                  {
                    Header: "Report Name",
                    accessor: "report_name",
                    isFilter: true,
                  },
                  {
                    Header: "Address",
                    accessor: "address",
                    isFilter: true,
                  },
                  {
                    Header: "Assigned User",
                    accessor: "user_name",
                    isFilter: true,
                  },
                  {
                    Header: "Codeset",
                    accessor: "codeset_name",
                    isFilter: true,
                  },
                  {
                    Header: "Generated",
                    accessor: "createdAt",
                    isFilter: false,
                  },
                  {
                    Header: "Status",
                    accessor: "status",
                    isFilter:true,
                    Cell: ({ value }) => {
                      // Map status values to corresponding strings
                      const statusMap = {
                        0: "Inactive",
                        1: "Complete",
                        2: "In Progress",
                        // Add more mappings as needed
                      };

                      // Display the mapped status string
                      return <span>{statusMap[value]}</span>;
                    },
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    isFilter:false,
                  },
                ]}
                data={datatable}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalPages={totalPages}
                isLoading={isLoading}
                setFilterValues={setFilterValues}
                filterValues={filterValues}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                setSortColumn={setSortColumn}
                setOrder={setOrder}
              />
            </CardBody>
          </div>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
